export interface DocumentDialogData {
  contractId: number;
  moduleId: number;
  moduleCode: string;
  moduleName: string;
  entityInstanceId: number;
  isInitiator?: boolean;
  fromItemId?: number;
  presetId?: number;
  screenId?: number;
  paymentPeriodId?: number;
  relationId?: number;
  [key: string]: any;
}

export interface PdfHandlerProps {
  moduleId: number;
  moduleName: string;
  moduleCode: string;
  contractId: number;
  entityInstanceId?: number;
  contractNo: string;
  correspondenceOperations: Record<string, boolean>;
}

export interface PdfMarkupDialogProps {
  documentId: string;
  fileId: number;
  title: string;
  entityInstanceId: number;
}
